// extracted by mini-css-extract-plugin
module.exports = {"energy-maps":"_5DQZzzpq","energy-map":"_5D2DnS7c"};